<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">

        <sequences-form :sequence="sequence" :reel="reel" :loader="loader" @click="storeSequence(sequence)"
                        :showLabels="false"></sequences-form>

      </div>
    </div>
  </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import sequencesApi from '../../api/sequences'
  import sequencesForm from './SequencesForm.vue'
  import Sequence from '../../models/sequence'

  export default {

    components: {
      sequencesForm
    },
    data () {
      return {
        sequence: new Sequence(true),
        reel: this.$store.state.ui.actualReel,
        loader: false
      }
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Inserisci nuova sequenza',
        createButton: {display: false}
      })
      this.$emit('addBackgroundColor', 'rgb(234,186,140)')
    },

    methods: {
      storeSequence (sequence) {
        this.loader = true
        sequencesApi.store(sequence)
          .then((response) => {
            toastr.success('La sequenza è stata inserita correttamente')
            this.$router.replace({name: 'sequencesShow', params: {id: response.data.data.id}})
          })
          .catch((response) => {
            this.loader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/sequences/SequencesCreate.vue